import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import { useQuery } from '../hooks';
import HomeDashboardPageQuery from '../models/home-dashboard-page-query.model';
import { authenticate } from '../store/sign-in/sign-in-actions';

export interface PublicRouteProps extends RouteProps { }
const PublicRoute: React.FC<PublicRouteProps> = ({ ...props }) => {
    const [query] = useQuery<HomeDashboardPageQuery>();
    const dispatch = useDispatch();

    useEffect(() => {
        if (query.token) {
            dispatch(authenticate({ tokenKey: query.token, event: 'talent-match' }));
        }
    }, [query, dispatch]);

    return (
        <Route {...props} />
    );
};

export default PublicRoute;
